import React, { useEffect, useState } from 'react';
import { Loader } from 'react-feather';
import ManageTable from '../../../Manage/ManageTable';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, Input, Row, Col } from 'reactstrap';
import ReloadGiftCard from '../ReloadGiftCard';
import { NewsLetterStyle } from '../../../../StyledComponents';
import { IoCaretBackOutline } from 'react-icons/io5';
import TransactionHistory from '../TransactionHistory';


const AllGiftCards = () => {
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState([]);

  const [modal, setModal] = useState(false);
  const handleModal = () => setModal(!modal);

  const [showForm, setShowForm] = useState(false);

  const handleAdd = () => {
      setShowForm(false);
  };

  const [data, setData] = useState([]);
  const [name, setName] = useState([]);

  const clickHandler = (name, data) => {
      setShowForm(true);
      setData(data)
      setName(name)
  };                            


  const giftCardData = [
    {
      giftCardNo: "1234-5678-9101",
      type: "E-Gift",
      amount: "$50",
      remaining: "$50",
      validityPeriod: "01/01/2024 - 01/01/2025",
      applicability: "ABC Store",
      status: "Active",
      autoReload: true,
    },
    {
      giftCardNo: "1234-5678-9101",
      type: "Physical",
      amount: "$50",
      remaining: "$50",
      validityPeriod: "01/01/2024 - 01/01/2025",
      applicability: "ABC Store",
      status: "Expired",
      autoReload: true,
    },
    {
      giftCardNo: "1234-5678-9101",
      type: "Maelano",
      amount: "$50",
      remaining: "$50",
      validityPeriod: "01/01/2024 - 01/01/2025",
      applicability: "All Products",
      status: "Active",
      autoReload: true,
    },
    {
      giftCardNo: "1234-5678-9101",
      type: "E-Gift",
      amount: "$50",
      remaining: "$0",
      validityPeriod: "01/01/2024 - 01/01/2025",
      applicability: "All Products",
      status: "Fully Used",
      autoReload: false,
    },
    {
      giftCardNo: "1234-5678-9101",
      type: "Brand-specific",
      amount: "$50",
      remaining: "$50",
      validityPeriod: "01/01/2024 - 01/01/2025",
      applicability: "ABC Brand",
      status: "Expired",
      autoReload: false,
    },
    {
      giftCardNo: "1234-5678-9101",
      type: "E-Gift",
      amount: "$50",
      remaining: "$50",
      validityPeriod: "01/01/2024 - 01/01/2025",
      applicability: "ABC Store",
      status: "Active",
      autoReload: false,
    },
    {
      giftCardNo: "1234-5678-9101",
      type: "Customizable",
      amount: "$50",
      remaining: "$0",
      validityPeriod: "01/01/2024 - 01/01/2025",
      applicability: "All Products",
      status: "Fully Used",
      autoReload: false,
    }
  ];

  useEffect(() => {
    // Simulate fetching data
    setTableData(giftCardData);
    setLoading(false);
  }, []);

  const ActionColumn = ({ row }) => (
    <div title='Action' className="ellipsis">
      <UncontrolledDropdown>
        <DropdownToggle tag="div" style={{ cursor: 'pointer' }} onClick={(e) => e.preventDefault()}>
          Action
        </DropdownToggle>
        <DropdownMenu className="overflow-hidden text-nowrap pe-4">
          <DropdownItem onClick={() => clickHandler("Transaction History", row)}>View Transaction History</DropdownItem>
          <DropdownItem onClick={() => clickHandler("Reload Gift Card", row)}>Reload Gift Card</DropdownItem>
          <DropdownItem toggle={false} className="no-background-change">
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
              <div style={{ color: '#000' }}>
                 Auto Reload
              </div>
                <div className="form-check form-switch">
                  <Input
                    type="switch"
                    name="customSwitch"
                    id="exampleCustomSwitch"
                    checked={row.autoReload || false} // Use row.autoReload if defined
                    onChange={(e) => handleAutoReloadChange(!row.autoReload, row)} // Pass the checked state
                    style={{
                      backgroundColor: row.autoReload ? '#FBBD34' : '', // Change background color based on checked state
                      borderColor: row.autoReload ? '#FBBD34' : '', // Change border color based on checked state
                      cursor: 'pointer', // Keep pointer for better UX
                    }}
                  />
                </div>
            </div>
           
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
    </div>
  );

  const handleAutoReloadChange = (isChecked, row) => {
    const updatedTableData = tableData.map((giftCard) => {
      if (giftCard.giftCardNo === row.giftCardNo) {
        return { ...giftCard, autoReload: isChecked }; 
      }
      return giftCard; 
    });
  
    setTableData(updatedTableData); 
  };

  const columns = [
    {
      name: "Gift Card No.",
      cell: (row) => <span title={row.giftCardNo} className="ellipsis">{row.giftCardNo}</span>,
      selector: (row) => row.giftCardNo,
      sortable: true,
    },
    {
      name: "Type",
      cell: (row) => <span title={row.type} className="ellipsis">{row.type}</span>,
      selector: (row) => row.type,
      sortable: true,
    },
    {
      name: "Amount",
      cell: (row) => <span title={row.amount} className="ellipsis">{row.amount}</span>,
      selector: (row) => row.amount,
      sortable: true,
    },
    {
      name: "Remaining",
      cell: (row) => <span title={row.remaining} className="ellipsis">{row.remaining}</span>,
      selector: (row) => row.remaining,
      sortable: true,
    },
    {
      name: "Validity Period",
      cell: (row) => <span title={row.validityPeriod} className="ellipsis">{row.validityPeriod}</span>,
      selector: (row) => row.validityPeriod,
      sortable: true,
    },
    {
      name: "Applicability",
      cell: (row) => <span title={row.applicability} className="ellipsis">{row.applicability}</span>,
      selector: (row) => row.applicability,
      sortable: true,
    },
    {
      name: "Status",
      cell: (row) => (
        <span
          title={row.status}
          className="ellipsis"
          style={{ color: row.status === 'Active' ? '#41B8E4' : row.status === 'Expired' || row.status === 'Fully Used' ? '#EC7426' : '#000' }}
        >
          {row.status}
        </span>
      ),
      selector: (row) => row.status,
      sortable: true,
    },
    {
      name: "Action",
      cell: (row) => <ActionColumn row={row} />,
      selector: (row) => 'Action',
      sortable: true,
    },
  ];

  return (
    <>
{showForm ? (
      <>
        {
          name == 'Reload Gift Card' ? 
          <ReloadGiftCard onSwitchTab={''}  data={data} showState={handleAdd} onCancel={() => setShowForm(false)} />
          : name == 'Transaction History' ?
          <TransactionHistory onSwitchTab={''}  data={data} showState={handleAdd} onCancel={() => setShowForm(false)}/>
          : ""

        }
              
      </>
  ) : (
      <div>
        {loading ? <Loader /> :
          <ManageTable
            name={'All Gift Cards'}
            columns={columns}
            setTableData={setTableData}
            tableData={tableData}
          />
        }
      </div>
)}
    </>
  );
};

export default AllGiftCards;
